import EventBus, { Event } from './event-bus';

export class ResizeEmitter {

    private el?: Element;

    private eventBus: EventBus;

    private resizeObserver: ResizeObserver;

    constructor(eventBus: EventBus) {
        this.eventBus = eventBus;
        this.resizeObserver = new ResizeObserver(this.onResize.bind(this));
    }

    public init(el: Element): void {
        this.el = el;
        this.resizeObserver.observe(this.el);
        window.addEventListener('resize', this.onWindowResize.bind(this));
    }

    public destroy(): void {
        this.resizeObserver.disconnect();
    }

    private onResize(entries: ResizeObserverEntry[]): void {
        const entry = entries[0];
        const { width, height } = entry.contentRect;

        this.eventBus.emit(Event.resize, { width, height }, 'root');
    }

    private onWindowResize(event: UIEvent): void {
        if (event.target === window && this.el) {
            const { width, height } = this.el.getBoundingClientRect();
            this.eventBus.emit(Event.resize, { width, height }, 'window');
        }
    }
}
